import { getCoprincipalMailboxInfoForMailboxInfo } from "owa-account-source-list-store";
import { getIndexerValueForMailboxInfo, type MailboxInfo } from "owa-client-types";

// The Rewards balance is per coprincipal account. Both the widget (write) and the button-width
// selector (read) derive the store key from the module-context mailbox through this helper so their
// keys always match.
export default function getRewardsAccountKey(moduleContextMailboxInfo: MailboxInfo): string {
    const coprincipal = getCoprincipalMailboxInfoForMailboxInfo(moduleContextMailboxInfo);
    return coprincipal ? getIndexerValueForMailboxInfo(coprincipal) : "";
}
